import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "CUSTOMERS";
export const customerConstants = createCRUDConstants(nameSpace);
